import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/checked.svg'


const _withScopeId = n => (_pushScopeId("data-v-27b6752a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  alt: "selected",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-2 relative transform ease-linear duration-75", {
      selectedClass: _ctx.selected,
      mouseDownClass: _ctx.mouseIsDown,
      'rounded-xl': _ctx.corners,
      'rounded-full': !_ctx.corners,
    }]),
    style: _normalizeStyle({ backgroundColor: _ctx.colour }),
    onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouseIsDown = true)),
    onMouseup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouseIsDown = false)),
    onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mouseIsDown = true)),
    onTouchend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mouseIsDown = false))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.selected)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute top-0 right-0 -m-2 rounded-full p-2 bg-green-highlight", { '-m-3': _ctx.corners }])
        }, _hoisted_2, 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */))
}